// extracted by mini-css-extract-plugin
module.exports = {"btnGroup":"VoiceControlEditPage_btnGroup__2ukyf","button":"VoiceControlEditPage_button__xdLHa","typeSkeleton":"VoiceControlEditPage_typeSkeleton__2JUTX"};